import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // CRITICAL: If returning from the Google OAuth callback, skip the /me check.
    // AuthCallback will exchange the token and establish the session first.
    if (window.location.hash?.includes('token=')) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem('zeezo_token');
    const savedUser = localStorage.getItem('zeezo_user');
    if (token && savedUser) {
      try {
        const res = await api.get('/auth/me');
        setUser(res.data);
        localStorage.setItem('zeezo_user', JSON.stringify(res.data));
      } catch {
        localStorage.removeItem('zeezo_token');
        localStorage.removeItem('zeezo_user');
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem('zeezo_token', token);
    localStorage.setItem('zeezo_user', JSON.stringify(userData));
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch {}
    setUser(null);
    localStorage.removeItem('zeezo_token');
    localStorage.removeItem('zeezo_user');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
